module.exports = __webpack_public_path__ + "img/advice-d.ecea34c7.png";